import { render, staticRenderFns } from "./afterSalesDetall.vue?vue&type=template&id=63ad6012&scoped=true&"
import script from "./afterSalesDetall.vue?vue&type=script&lang=js&"
export * from "./afterSalesDetall.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesDetall.vue?vue&type=style&index=0&id=63ad6012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad6012",
  null
  
)

export default component.exports